import { render, staticRenderFns } from "./PasswordSend.vue?vue&type=template&id=ed9ec0f8&scoped=true&"
import script from "./PasswordSend.vue?vue&type=script&lang=js&"
export * from "./PasswordSend.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSend.vue?vue&type=style&index=0&id=ed9ec0f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9ec0f8",
  null
  
)

export default component.exports